















































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';
import { Camera } from '@/models/camera';
import { Phase } from '@/models/phase';
import CameraModal from '@/components/cameramodal/cameramodal.component.vue';
import CameraModalCreate from '@/components/cameramodalcreate/cameramodalcreate.component.vue';
import { Project } from '@/models/project';
import { User } from '@/models/user';
import { Photo } from '@/models/photo';
import { Video } from '@/models/video';
import { Album } from '@/models/album';
import ProjectModal from '@/components/projectmodal/projectmodal.component.vue';
// @ts-ignore: no d.ts file
import { vTeleport } from '@desislavsd/vue-teleport';
import Gallery from '../components/gallery/gallery.component.vue';
import GalleryCompare from '../components/gallerycompare/gallerycompare.component.vue';
import AlbumComponent from '../components/album/album.component.vue';
import IAComponent from '../components/ia/ia.component.vue';
import AudioComponent from '../views/Audio.vue';
import Scenario from '../components/scenario/scenario.component.vue';
import TimelapseCard from '../components/timelapsecard/timelapsecard.component.vue';
import Livestream from '../components/livestream/livestream.component.vue';
import CameraGalleryList from '../views/CameraGalleryList.vue';
import Data from '../components/data/data.component.vue';
import Description from '../components/description/description.component.vue';
import { NotificationMessage, Socket } from '@/store/types';
import { Logger } from 'aws-amplify';
import Shepherd from 'shepherd.js';
import 'shepherd.js/dist/css/shepherd.css';
import { offset } from '@floating-ui/dom';
import { Auth } from 'aws-amplify';
import { cameraService } from '@/services';
import AWS from 'aws-sdk';
const logger = new Logger('PlateformCentral');

async function configureAWSCredentials() {
  try {
    const credentials = await Auth.currentCredentials();
    AWS.config.update({
      credentials: credentials,
      region: 'eu-west-3', // Remplacez par votre région AWS
    });
    //console.log('AWS Credentials configurés avec succès.');
  } catch (error) {
    console.error('Erreur lors de la configuration des credentials AWS:', error);
  }
}

@Component({
  components: {
    vTeleport,
    Gallery,
    GalleryCompare,
    AlbumComponent,
    IAComponent,
    Scenario,
    TimelapseCard,
    Livestream,
    Data,
    Description,
    ProjectModal,
    CameraModal,
    CameraModalCreate,
    CameraGalleryList,
    AudioComponent,
  },
})
export default class PlateformCentral extends Vue {
  @Prop(String) readonly id!: string;
  @Prop({ default: null }) readonly cameraId!: string;

  @State('user', { namespace: 'profile' }) private user!: User;
  @State('premium', { namespace: 'profile' }) readonly isPremium!: boolean;

  @State('projects', { namespace: 'projects' }) readonly projects!: Project[];
  @Getter('projectWithId', { namespace: 'projects' }) readonly projectWithId!: (id: string) => Project | undefined;

  @State('timelapse', { namespace: 'project' }) readonly timelapse!: Video[];
  @State('premium', { namespace: 'project' }) readonly ownerPremium!: boolean;
  @Getter('timelapseForCamera', { namespace: 'project' }) readonly timelapseForCamera!: (
    cameraId: string
  ) => Video | null;
  @Action('setProject', { namespace: 'project' }) readonly setProject!: (project: Project) => Promise<void>;

  @Action('findAllFor', { namespace: 'photo' }) readonly findPhotoAllForProject!: (payload: {
    projectId: string;
    cameraId: string;
  }) => Promise<Photo[]>;
  @Action('loadAlbum', { namespace: 'album' }) readonly loadAlbum!: (payload: {
    projectId: string;
    cameraId: string;
  }) => Promise<Album[]>;

  @State('socket') readonly socketMessage!: Socket;
  @Action('connectSocket') readonly connectSocket!: () => Promise<void>;
  @Action('disconnectSocket') readonly disconnectSocket!: () => Promise<void>;
  @Mutation('SOCKET_ONMESSAGE') readonly resetSocketMessage!: (object: string) => void;

  private project: Project | null = null;
  private album: Album | null = null;
  private photos: Photo[] = [];
  private lastVideo: Video | null = null;
  private galleryComparaison: string | null = null;
  private newPhotoAvailable = false;
  private showGalleryList = false;
  private syncGalleries = false;
  private logoUrl: string | null = null;
  private showLogoActions = false;
  private perRow = 2;

  increaseCols(): void {
    if (this.perRow < 6) {
      this.perRow++;
      console.log('perRow++ =>', this.perRow);
    }
  }

  decreaseCols(): void {
    if (this.perRow > 1) {
      this.perRow--;
      console.log('perRow-- =>', this.perRow);
    }
  }

  public get galleryStyle() {
    // Détecte mobile / tablette
    const isNarrow = window.matchMedia('(max-width: 1125px)').matches;

    // Cap “desktop” selon l’optique (ce que tu faisais avec 117vh / 155vh)
    const desktopCapVh = this.camera && this.camera.optic !== '4260x1534' ? 117 : 155;
    const desktopCapVhMax = desktopCapVh * 1.5;

    // Sur mobile : largeur plein écran, ZÉRO overflow
    if (isNarrow) {
      return {
        // 100vw = largeur écran, on interdit tout dépassement
        width: '100vw',
        maxWidth: '100vw',
        // Empêche les enfants de provoquer un scroll horizontal
        overflowX: 'hidden',
        boxSizing: 'border-box',
        // pour corriger certains devices avec barres UI
        paddingInline: '0',
      };
    }

    // Sur desktop : borne la largeur avec clamp
    // - min 520px pour éviter un layout rikiki
    // - prefer 90vw (s’adapte à la place)
    // - max desktopCapVh (ta logique d’origine basée sur la hauteur)
    return {
      // clamp(min, ideal, max)
      width: `clamp(520px, 90vw, ${desktopCapVh}vh)`,
      maxWidth: `min(100vw, ${desktopCapVhMax}vh)`,
      boxSizing: 'border-box',
    };
  }

  public get cameraSelected(): string | null {
    return (this.$route.query.camera as string) || null;
  }
  public set cameraSelected(s: string | null) {
    if (s !== null && this.$route.query.camera !== s) {
      this.$router.replace({ path: this.$route.path, query: { ...this.$route.query, camera: s } });
    }
  }

  public get camera(): Camera | undefined {
    logger.info('get camera ' + this.cameraSelected);
    return (
      this.project?.cameras?.find((camera) => camera.id === this.cameraSelected) ||
      this.project?.previousCameras?.find((camera) => camera.id === this.cameraSelected)
    );
  }

  public get galleryWidth(): string {
    if (window.innerWidth > 500) {
      return this.camera && this.camera.optic !== '4260x1534' ? '117vh' : '155vh';
    }
    return '100%'; // ou une autre valeur par défaut pour les petits écrans
  }

  public get breadcrumbs(): unknown[] {
    const items = [
      {
        text: this.$tc('global.project', 2),
        to: '/',
      },
    ];
    if (this.project) {
      items.push({
        text: this.project.name,
        to: '#',
      });
    }
    return items;
  }

  resizing = false;

  startResize(event: MouseEvent) {
    this.resizing = true;
    window.addEventListener('mousemove', this.performResize);
    window.addEventListener('mouseup', this.stopResize);
  }

  performResize(event: MouseEvent) {
    if (this.resizing) {
      const galleryElement = this.$el.querySelector('.gallery') as HTMLElement;
      if (galleryElement !== null) {
        const newWidth = event.clientX - galleryElement.getBoundingClientRect().left;
        galleryElement.style.width = `${newWidth}px`;
      }
    }
  }

  stopResize() {
    if (this.resizing) {
      this.resizing = false;
      window.removeEventListener('mousemove', this.performResize);
      window.removeEventListener('mouseup', this.stopResize);
    }
  }

  private triggerLogoUpload() {
    (this.$refs.logoInput as HTMLInputElement).click();
  }

  private async handleLogoUpload(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) {
      console.error('❌ Aucun fichier sélectionné.');
      return;
    }

    try {
      const region = 'eu-west-3';
      const credentials = await Auth.currentCredentials();
      const s3 = new AWS.S3({ region, credentials });

      const ownerID = this.project?.owner?.id;
      const projectID = this.project?.id;
      if (!ownerID || !projectID) {
        console.error("❌ Impossible de récupérer l'ID du projet ou du propriétaire.");
        return;
      }

      const fileName = `logo-${Date.now()}.${file.name.split('.').pop()}`;
      const key = `public/${ownerID}/${projectID}/Logo/${fileName}`;

      const fileBuffer = await file.arrayBuffer();

      await s3
        .putObject({
          Bucket: 'erige-main-store-prod',
          Key: key,
          Body: Buffer.from(fileBuffer),
          ContentType: file.type,
          ACL: 'public-read',
        })
        .promise();

      console.log('✅ Logo uploadé avec succès:', key);
      this.fetchLogoUrl(); // Met à jour l'affichage après upload
    } catch (error) {
      console.error("❌ Erreur lors de l'upload du logo:", error);
    }
  }

  private relayGoToPhotoFromAudio(payload: { photoId: string; date: Date; cameraId: string; projectId: string }) {
    console.log('[PlateformCentral] go-to-photo-from-audio', payload);

    // Si on n’est pas sur la bonne caméra, on la sélectionne
    if (payload.cameraId && this.cameraSelected !== payload.cameraId) {
      this.cameraSelected = payload.cameraId;
    }

    // 1) Event global pour que Gallery (ou autre) puisse écouter facilement
    this.$root.$emit('go-to-photo-from-audio', payload);

    // 2) Appel direct si Gallery expose une API publique (à adapter dans Gallery.vue)
    const gallery = this.$refs.gallery as any;
    if (gallery && typeof gallery.focusPhotoById === 'function') {
      gallery.focusPhotoById(payload.photoId, payload.date);
    }
  }

  public async fetchLogoUrl() {
    try {
      if (!this.project || !this.project.owner) {
        console.warn('❌ `project` ou `project.owner` est indéfini. Attente...');
        return;
      }

      const region = 'eu-west-3';
      const credentials = await Auth.currentCredentials();
      const s3 = new AWS.S3({ region, credentials });

      const ownerID = this.project.owner.id;
      const projectID = this.project.id;

      console.log('🔹 Récupération du logo pour ownerID:', ownerID, 'projectID:', projectID);

      const prefix = `public/${ownerID}/${projectID}/Logo/`;

      const response = await s3
        .listObjectsV2({
          Bucket: 'erige-main-store-prod',
          Prefix: prefix,
        })
        .promise();

      if (response.Contents && response.Contents.length > 0) {
        const lastFile = response.Contents.sort(
          (a, b) => (b.LastModified?.getTime() || 0) - (a.LastModified?.getTime() || 0)
        )[0];

        if (lastFile && lastFile.Key) {
          this.logoUrl = s3.getSignedUrl('getObject', {
            Bucket: 'erige-main-store-prod',
            Key: lastFile.Key,
            Expires: 3600,
          });

          console.log('✅ URL du logo récupérée :', this.logoUrl);
        }
      } else {
        console.warn('❌ Aucun logo trouvé dans le bucket.');
      }
    } catch (error) {
      console.error('Erreur lors de la récupération du logo :', error);
    }
  }

  private async deleteAllLogos() {
    try {
      if (!this.project || !this.project.owner) return;

      const region = 'eu-west-3';
      const credentials = await Auth.currentCredentials();
      const s3 = new AWS.S3({ region, credentials });

      const ownerID = this.project.owner.id;
      const projectID = this.project.id;
      const prefix = `public/${ownerID}/${projectID}/Logo/`;

      // Liste des fichiers à supprimer
      const response = await s3.listObjectsV2({ Bucket: 'erige-main-store-prod', Prefix: prefix }).promise();
      if (!response.Contents || response.Contents.length === 0) {
        console.warn('❌ Aucun logo à supprimer.');
        return;
      }

      const deleteParams = {
        Bucket: 'erige-main-store-prod',
        Delete: { Objects: response.Contents.map((item) => ({ Key: item.Key! })) },
      };

      await s3.deleteObjects(deleteParams).promise();
      this.logoUrl = null; // Supprime l'affichage du logo après suppression
      console.log('✅ Tous les logos ont été supprimés.');
    } catch (error) {
      console.error('❌ Erreur lors de la suppression des logos:', error);
    }
  }

  public async toggleGalleryView() {
    this.showGalleryList = !this.showGalleryList;
    if (this.showGalleryList && this.project && this.project.cameras) {
      for (const cam of this.project.cameras) {
        await this.findPhotoAllForProject({ projectId: this.id, cameraId: cam.id });
      }
    }
  }

  public get camerasOptions(): unknown[] {
    const project = this.project;
    const data = [
      ...(project?.cameras?.map((camera) => {
        return {
          text: `${camera.name}`,
          value: camera.id,
        };
      }) ?? []),
      ...(project?.previousCameras?.map((camera) => {
        return {
          text: `${camera.name} (deleted)`,
          value: camera.id,
        };
      }) ?? []),
    ];
    if (data.length > 0) {
      return data;
    } else {
      return [{ text: this.$t('plateformcentral.noCamera').toString(), value: null }];
    }
  }

  public get guest(): boolean {
    return !!this.project?.guestId?.includes(this.user.id);
  }

  public get isAdmin(): boolean {
    if (this.user && this.project) {
      return (
        this.project.owner.id === this.user.id ||
        (this.project.administratorId && this.project.administratorId.includes(this.user.id))
      );
    }
    return false;
  }

  public onSyncToggle() {
    console.log('Sync galleries toggled:', this.syncGalleries);
  }

  public initShepherd() {
    if (this.project && this.project.unpaid) {
      const tour = new Shepherd.Tour({
        defaultStepOptions: {
          cancelIcon: {
            enabled: true,
          },
        },
      });

      tour.addStep({
        title: 'Avis de paiement en retard',
        text: "<strong>Attention:</strong> Une situation d'impayés a été remarqué sur votre compte. <br>Afin de continuer à bénéficier de votre interface, merci de vérifier les factures en attente de règlement ou de vous rapprocher de votre commercial.",
        buttons: [
          {
            text: 'Compris',
            action: tour.next,
          },
        ],
      });

      tour.start();
    }
  }

  public async onCreatePhase(payload: {
    name: string;
    date: string | Date;
    color?: string;
    start?: string | Date | null;
    end?: string | Date | null;
    lane?: string;
  }): Promise<void> {
    if (!this.camera || !this.project || !this.project.cameras) return;

    const toDate = (value: string | Date | null | undefined, previous?: Date): Date | undefined => {
      if (value === undefined) return previous; // champ non modifié
      if (value === null) return undefined; // on veut effacer la valeur
      return typeof value === 'string' ? new Date(value) : value;
    };

    const dateObj = toDate(payload.date as any);
    if (!dateObj) {
      console.error('Payload date is invalid', payload.date);
      return;
    }
    const startObj = toDate(payload.start ?? null);
    const endObj = toDate(payload.end ?? null);

    try {
      const updated = await cameraService.createPhase(this.camera.id, {
        name: payload.name,
        date: dateObj,
        color: payload.color,
        start: startObj,
        end: endObj,
        lane: payload.lane,
      });

      if (updated) {
        const idx = this.project.cameras.findIndex((c) => c.id === updated.id);
        if (idx !== -1) {
          this.$set(this.project.cameras, idx, updated);
        } else if (this.project.previousCameras) {
          const idxPrev = this.project.previousCameras.findIndex((c) => c.id === updated.id);
          if (idxPrev !== -1) {
            this.$set(this.project.previousCameras, idxPrev, updated);
          }
        }

        this.$bvToast.toast(this.$t('gallery.phaseSaved').toString(), {
          title: this.$t('global.success').toString(),
          variant: 'success',
          solid: true,
        });
      } else {
        throw new Error('Empty response from server');
      }
    } catch (error) {
      console.error('Erreur enregistrement phase', error);
      this.$bvToast.toast(this.$t('gallery.phaseSaveError').toString(), {
        title: this.$t('global.error').toString(),
        variant: 'danger',
        solid: true,
      });
    }
  }

  /**
   * Update d’un jalon existant
   * payload = { id, name }
   */
  public async onUpdatePhase(payload: {
    id: string;
    name: string;
    color?: string;
    date?: string | Date | null;
    start?: string | Date | null;
    end?: string | Date | null;
    lane?: string;
  }): Promise<void> {
    if (!this.camera || !this.project || !this.project.cameras) return;

    const currentPhase = (this.camera.phases || []).find((p: Phase) => p.id === payload.id);

    if (!currentPhase) {
      console.warn('Phase non trouvée pour la mise à jour', payload.id);
      this.$bvToast.toast(this.$t('gallery.phaseNotFound').toString(), {
        title: this.$t('global.error').toString(),
        variant: 'danger',
        solid: true,
      });
      return;
    }

    const normalize = (value: string | Date | null | undefined, previous?: string): string | undefined => {
      if (value === undefined) return previous; // champ non modifié
      if (value === null) return undefined; // on veut effacer la valeur
      return typeof value === 'string' ? value : value.toISOString();
    };

    const normalizedDate = normalize(payload.date, currentPhase.date);
    const normalizedStart = normalize(payload.start, (currentPhase as any).start);
    const normalizedEnd = normalize(payload.end, (currentPhase as any).end);

    const phaseToSend: Phase = {
      ...currentPhase,
      name: payload.name,
      color: payload.color ?? currentPhase.color,
      // 🔥 on met à jour la "date" si le payload en fournit une, sinon on garde l'ancienne
      date: normalizedDate ?? currentPhase.date,
      start: normalizedStart ?? (currentPhase as any).start,
      end: normalizedEnd ?? (currentPhase as any).end,
      lane: payload.lane ?? (currentPhase as any).lane,
    };

    try {
      const updated = await cameraService.updatePhase(this.camera.id, phaseToSend);

      if (updated) {
        // Mise à jour dans project.cameras ou previousCameras
        const idx = this.project.cameras.findIndex((c) => c.id === updated.id);
        if (idx !== -1) {
          this.$set(this.project.cameras, idx, updated);
        } else if (this.project.previousCameras) {
          const idxPrev = this.project.previousCameras.findIndex((c) => c.id === updated.id);
          if (idxPrev !== -1) {
            this.$set(this.project.previousCameras, idxPrev, updated);
          }
        }

        this.$bvToast.toast(this.$t('gallery.phaseSaved').toString(), {
          title: this.$t('global.success').toString(),
          variant: 'success',
          solid: true,
        });
      } else {
        throw new Error('Empty response from server');
      }
    } catch (error) {
      console.error('Erreur mise à jour phase', error);
      this.$bvToast.toast(this.$t('gallery.phaseSaveError').toString(), {
        title: this.$t('global.error').toString(),
        variant: 'danger',
        solid: true,
      });
    }
  }

  /**
   * Suppression d’un jalon existant
   * payload = { id }
   */
  public async onDeletePhase(payload: { id: string }): Promise<void> {
    if (!this.camera || !this.project || !this.project.cameras) return;

    try {
      // 👉 adapte aussi ici selon ton service
      const updated = await cameraService.deletePhase(this.camera.id, payload.id);

      if (updated) {
        const idx = this.project.cameras.findIndex((c) => c.id === updated.id);
        if (idx !== -1) {
          this.$set(this.project.cameras, idx, updated);
        } else if (this.project.previousCameras) {
          const idxPrev = this.project.previousCameras.findIndex((c) => c.id === updated.id);
          if (idxPrev !== -1) {
            this.$set(this.project.previousCameras, idxPrev, updated);
          }
        }

        this.$bvToast.toast(this.$t('gallery.phaseDeleted').toString(), {
          title: this.$t('global.success').toString(),
          variant: 'success',
          solid: true,
        });
      } else {
        throw new Error('Empty response from server');
      }
    } catch (error) {
      console.error('Erreur suppression phase', error);
      this.$bvToast.toast(this.$t('gallery.phaseDeleteError').toString(), {
        title: this.$t('global.error').toString(),
        variant: 'danger',
        solid: true,
      });
    }
  }

  public async mounted(): Promise<void> {
    logger.info('mounted');
    await configureAWSCredentials();
    this.onStateProjectLoaded(this.projects, undefined);
    this.connectSocket();
    if (this.project) {
      await this.fetchLogoUrl();
    }
    this.$nextTick(() => {
      setTimeout(() => {
        this.initShepherd();
      }, 5000);

      setTimeout(() => {
        if (localStorage.getItem('tourIgnored')) {
          return;
        }
        if (window.innerWidth >= 700) {
          const tour = new Shepherd.Tour({
            defaultStepOptions: {
              cancelIcon: {
                enabled: true,
              },
              classes: 'shepherd-content', // Ajoutez votre propre classe CSS
              scrollTo: true,
              when: {
                show() {
                  const currentStep = Shepherd.activeTour?.getCurrentStep();
                  if (!currentStep) return;
                  const currentStepElement = currentStep.getElement();
                  if (!currentStepElement) return;
                  const header = currentStepElement.querySelector('.shepherd-footer');
                  if (!header) return;
                  const progress = document.createElement('div');
                  const innerBar = document.createElement('span');
                  const progressPercentage = ((tour.steps.indexOf(currentStep) + 1) / tour.steps.length) * 100 + '%';
                  progress.className = 'shepherd-progress-bar';
                  innerBar.style.width = progressPercentage;
                  if (document.getElementsByClassName('shepherd-button').length == 1) {
                    progress.style.minWidth = '260px';
                  }
                  progress.appendChild(innerBar);
                  const headerh = currentStepElement.querySelector('.shepherd-header');
                  const progressh = document.createElement('span');
                  progressh.style.marginRight = '0px';
                  progressh.innerText = `${tour.steps.indexOf(currentStep) + 1}/${tour.steps.length}`;
                  if (headerh) {
                    headerh.insertBefore(progressh, currentStepElement.querySelector('.shepherd-cancel-icon'));
                  }
                  header.insertBefore(progress, currentStepElement.querySelector('.shepherd-button'));
                },
              },
            },
            useModalOverlay: true,
            keyboardNavigation: false,
          });

          tour.addStep({
            title: this.$t('plateformcentral.step1title').toString(),
            text: this.$t('plateformcentral.step1text').toString(),
            attachTo: {
              element: 'nothing', // La classe CSS d  e l'élément que vous voulez souligner
              on: 'left',
            },
            buttons: [
              {
                action: () => {
                  localStorage.setItem('tourIgnored', 'true');
                  tour.complete();
                },
                text: this.$t('projectlist.donotshow').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: tour.next,
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
          });
          tour.addStep({
            title: this.$t('plateformcentral.step2title').toString(),
            text: this.$t('plateformcentral.step2text').toString(),
            attachTo: {
              element: '.cameraSelectList ', // La classe CSS de l'élément que vous voulez souligner
              on: 'right',
            },
            buttons: [
              {
                action: tour.back,
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: tour.next,
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 10, crossAxis: 0 })],
            },
          });
          tour.addStep({
            title: this.$t('plateformcentral.step3title').toString(),
            text: this.$t('plateformcentral.step3text').toString(),
            attachTo: {
              element: '.gallery-photo-preview-action', // La classe CSS de l'élément que vous voulez souligner
              on: 'right',
            },
            buttons: [
              {
                action: tour.back,
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: tour.next,
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 10, crossAxis: -60 })],
            },
            canClickTarget: false,
          });

          tour.addStep({
            title: this.$t('plateformcentral.step4title').toString(),
            text: this.$t('plateformcentral.step4text').toString(),
            attachTo: {
              element: '.gallery-action', // La classe CSS de l'élément que vous voulez souligner
              on: 'right',
            },
            buttons: [
              {
                action: tour.back,
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: tour.next,
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 20, crossAxis: 0 })],
            },
            canClickTarget: false,
          });
          tour.addStep({
            title: this.$t('plateformcentral.step405title').toString(),
            text: this.$t('plateformcentral.step405text').toString(),
            attachTo: {
              element: '.picto-flag', // La classe CSS de l'élément que vous voulez souligner
              on: 'right',
            },
            buttons: [
              {
                action: tour.back,
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: tour.next,
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 20, crossAxis: 0 })],
            },
            canClickTarget: false,
          });
          tour.addStep({
            title: this.$t('plateformcentral.step41title').toString(),
            text: this.$t('plateformcentral.step41text').toString(),
            attachTo: {
              element: '.picto-coeur', // La classe CSS de l'élément que vous voulez souligner
              on: 'right',
            },
            buttons: [
              {
                action: tour.back,
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: tour.next,
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 20, crossAxis: 0 })],
            },
            canClickTarget: false,
          });
          tour.addStep({
            title: this.$t('plateformcentral.step42title').toString(),
            text: this.$t('plateformcentral.step42text').toString(),
            attachTo: {
              element: '.zoomerbtn', // La classe CSS de l'élément que vous voulez souligner
              on: 'right',
            },
            buttons: [
              {
                action: tour.back,
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: tour.next,
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 20, crossAxis: 0 })],
            },
            canClickTarget: false,
          });
          tour.addStep({
            title: this.$t('plateformcentral.step43title').toString(),
            text: this.$t('plateformcentral.step43text').toString(),
            attachTo: {
              element: '.picto-fullscreen', // La classe CSS de l'élément que vous voulez souligner
              on: 'right',
            },
            buttons: [
              {
                action: tour.back,
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: tour.next,
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 20, crossAxis: 0 })],
            },
            canClickTarget: false,
          });
          tour.addStep({
            title: this.$t('plateformcentral.step45title').toString(),
            text: this.$t('plateformcentral.step45text').toString(),
            attachTo: {
              element: '.picto-share', // La classe CSS de l'élément que vous voulez souligner
              on: 'right',
            },
            buttons: [
              {
                action: tour.back,
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: tour.next,
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 20, crossAxis: 0 })],
            },
            canClickTarget: false,
          });
          tour.addStep({
            title: this.$t('plateformcentral.step47title').toString(),
            text: this.$t('plateformcentral.step47text').toString(),
            attachTo: {
              element: '.picto-download', // La classe CSS de l'élément que vous voulez souligner
              on: 'right',
            },
            buttons: [
              {
                action: tour.back,
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: tour.next,
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 20, crossAxis: 0 })],
            },
            canClickTarget: false,
          });
          tour.addStep({
            title: this.$t('plateformcentral.step5title').toString(),
            text: this.$t('plateformcentral.step5text').toString(),
            attachTo: {
              element: '.comparebtn', // La classe CSS de l'élément que vous voulez souligner
              on: 'right',
            },
            buttons: [
              {
                action: tour.back,
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: tour.next,
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 20, crossAxis: 0 })],
            },
            canClickTarget: false,
          });
          tour.addStep({
            title: this.$t('plateformcentral.step6title').toString(),
            text: this.$t('plateformcentral.step6text').toString(),
            attachTo: {
              element: '.timelapsecard', // La classe CSS de l'élément que vous voulez souligner
              on: 'left',
            },
            buttons: [
              {
                action: function () {
                  // Aller directement à l'étape 10 (index 9)
                  tour.show(3);
                },
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: tour.next,
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 15, crossAxis: 0 })],
            },
            canClickTarget: false,
          });
          tour.addStep({
            title: this.$t('plateformcentral.step7title').toString(),
            text: this.$t('plateformcentral.step7text').toString(),
            attachTo: {
              element: '.scenariicard', // La classe CSS de l'élément que vous voulez souligner
              on: 'right',
            },
            buttons: [
              {
                action: tour.back,
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: function () {
                  let gripElement = document.querySelector('.album-title');
                  if (gripElement) {
                    (gripElement as HTMLElement).click();
                  }
                  tour.next();
                },
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 15, crossAxis: 0 })],
            },
            canClickTarget: false,
          });
          tour.addStep({
            title: this.$t('plateformcentral.step8title').toString(),
            text: this.$t('plateformcentral.step8text').toString(),
            attachTo: {
              element: '.albumcard', // La classe CSS de l'élément que vous voulez souligner
              on: 'left',
            },
            buttons: [
              {
                action: function () {
                  let gripElement = document.querySelector('.album-title');
                  if (gripElement) {
                    (gripElement as HTMLElement).click();
                  }
                  tour.back();
                },
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: function () {
                  let gripElement = document.querySelector('.album-title');
                  if (gripElement) {
                    (gripElement as HTMLElement).click();
                  }
                  let dataElement = document.querySelector('.data-title');
                  if (dataElement) {
                    (dataElement as HTMLElement).click();
                  }
                  tour.show(14);
                },
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 15, crossAxis: 0 })],
            },
            canClickTarget: false,
          });
          tour.addStep({
            title: this.$t('plateformcentral.step9title').toString(),
            text: this.$t('plateformcentral.step9text').toString(),
            attachTo: {
              element: '.picto-coeur', // La classe CSS de l'élément que vous voulez souligner
              on: 'left',
            },
            buttons: [
              {
                action: tour.back,
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
            ],
            advanceOn: { selector: '.picto-coeur', event: 'click' },
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 10, crossAxis: 0 })],
            },
          });
          tour.addStep({
            title: this.$t('plateformcentral.step10title').toString(),
            text: this.$t('plateformcentral.step10text').toString(),
            attachTo: {
              element: '.popover', // La classe CSS de l'élément que vous voulez souligner
              on: 'right',
            },
            advanceOn: { selector: '.creeralbum', event: 'click' },
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 10, crossAxis: 0 })],
            },
          });
          tour.addStep({
            title: this.$t('plateformcentral.step11title').toString(),
            text: this.$t('plateformcentral.step11text').toString(),
            attachTo: {
              element: '.datacard', // La classe CSS de l'élément que vous voulez souligner
              on: 'left',
            },
            buttons: [
              {
                action: function () {
                  let dataElement = document.querySelector('.data-title');
                  if (dataElement) {
                    (dataElement as HTMLElement).click();
                  }
                  let gripElement = document.querySelector('.album-title');
                  if (gripElement) {
                    (gripElement as HTMLElement).click();
                  }
                  tour.show(12);
                },
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: function () {
                  let dataElement = document.querySelector('.data-title');
                  if (dataElement) {
                    (dataElement as HTMLElement).click();
                  }
                  tour.next();
                },
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 15, crossAxis: 0 })],
            },
            canClickTarget: false,
          });
          tour.addStep({
            title: this.$t('plateformcentral.step12title').toString(),
            text: this.$t('plateformcentral.step12text').toString(),
            attachTo: {
              element: '.descriptioncard', // La classe CSS de l'élément que vous voulez souligner
              on: 'left',
            },
            buttons: [
              {
                action: function () {
                  let dataElement = document.querySelector('.data-title');
                  if (dataElement) {
                    (dataElement as HTMLElement).click();
                  }
                  tour.back();
                },
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: function () {
                  let gripElement = document.querySelector('.cc-nsge');
                  if (gripElement) {
                    (gripElement as HTMLElement).click();
                  }
                  tour.next();
                },
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 15, crossAxis: 0 })],
            },
            canClickTarget: false,
          });
          tour.addStep({
            title: this.$t('plateformcentral.step13title').toString(),
            text: this.$t('plateformcentral.step13text').toString(),
            attachTo: {
              element: '.cc-157aw', // La classe CSS de l'élément que vous voulez souligner
              on: 'left',
            },
            buttons: [
              {
                action: function () {
                  let dataElement = document.querySelector('.cc-1no03');
                  if (dataElement) {
                    (dataElement as HTMLElement).click();
                  }
                  tour.back();
                },
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: function () {
                  let gripElement = document.querySelector('.cc-nsge');
                  if (gripElement) {
                    (gripElement as HTMLElement).click();
                  }
                  tour.next();
                },
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 15, crossAxis: 0 })],
            },
          });
          tour.addStep({
            title: this.$t('plateformcentral.step13bistitle').toString(),
            text: this.$t('plateformcentral.step13bistext').toString(),
            attachTo: {
              element: '.fa-file-arrow-down', // La classe CSS de l'élément que vous voulez souligner
              on: 'left',
            },
            buttons: [
              {
                action: function () {
                  let dataElement = document.querySelector('.cc-imbb');
                  if (dataElement) {
                    (dataElement as HTMLElement).click();
                  }
                  tour.back();
                },
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: function () {
                  let gripElement = document.querySelector('.cc-nsge');
                  if (gripElement) {
                    (gripElement as HTMLElement).click();
                  }
                  tour.next();
                },
                text: this.$t('projectlist.next').toString(),
                classes: 'shepherd-button-next',
              },
            ],
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 15, crossAxis: 0 })],
            },
          });
          tour.addStep({
            title: this.$t('plateformcentral.step14title').toString(),
            text: this.$t('plateformcentral.step14text').toString(),
            attachTo: {
              element: '.fa-circle-info', // La classe CSS de l'élément que vous voulez souligner
              on: 'bottom',
            },
            buttons: [
              {
                action: function () {
                  let dataElement = document.querySelector('.cc-imbb');
                  if (dataElement) {
                    (dataElement as HTMLElement).click();
                  }
                  tour.back();
                },
                text: this.$t('projectlist.previous').toString(),
                classes: 'shepherd-button-ignore',
              },
              {
                action: tour.next,
                text: this.$t('projectlist.donotshow').toString(),
                classes: 'shepherd-button-next',
              },
            ],
            floatingUIOptions: {
              middleware: [offset({ mainAxis: 15, crossAxis: 0 })],
            },
            canClickTarget: false,
          });
          tour.start();
        }
      }, 2000);
    });
    this.$nextTick(() => {
      setTimeout(() => {
        this.startTourNewFeature();
      }, 5000);
    });
  }

  public startTour(): void {
    const tour = new Shepherd.Tour({
      defaultStepOptions: {
        cancelIcon: {
          enabled: true,
        },
        classes: 'shepherd-content', // Ajoutez votre propre classe CSS
        scrollTo: true,
        when: {
          show() {
            const currentStep = Shepherd.activeTour?.getCurrentStep();
            if (!currentStep) return;
            const currentStepElement = currentStep.getElement();
            if (!currentStepElement) return;
            const header = currentStepElement.querySelector('.shepherd-footer');
            if (!header) return;
            const progress = document.createElement('div');
            const innerBar = document.createElement('span');
            const progressPercentage = ((tour.steps.indexOf(currentStep) + 1) / tour.steps.length) * 100 + '%';
            progress.className = 'shepherd-progress-bar';
            innerBar.style.width = progressPercentage;
            if (document.getElementsByClassName('shepherd-button').length == 1) {
              progress.style.minWidth = '260px';
            }
            progress.appendChild(innerBar);
            const headerh = currentStepElement.querySelector('.shepherd-header');
            const progressh = document.createElement('span');
            progressh.style.marginRight = '0px';
            progressh.innerText = `${tour.steps.indexOf(currentStep) + 1}/${tour.steps.length}`;
            if (headerh) {
              headerh.insertBefore(progressh, currentStepElement.querySelector('.shepherd-cancel-icon'));
            }
            header.insertBefore(progress, currentStepElement.querySelector('.shepherd-button'));
          },
        },
      },
      useModalOverlay: true,
      keyboardNavigation: false,
    });

    tour.addStep({
      title: this.$t('plateformcentral.step1title').toString(),
      text: this.$t('plateformcentral.step1text').toString(),
      attachTo: {
        element: 'nothing', // La classe CSS d  e l'élément que vous voulez souligner
        on: 'left',
      },
      buttons: [
        {
          action: () => {
            localStorage.setItem('tourIgnored', 'true');
            tour.complete();
          },
          text: this.$t('projectlist.donotshow').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: tour.next,
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
    });
    tour.addStep({
      title: this.$t('plateformcentral.step2title').toString(),
      text: this.$t('plateformcentral.step2text').toString(),
      attachTo: {
        element: '.cameraSelectList ', // La classe CSS de l'élément que vous voulez souligner
        on: 'right',
      },
      buttons: [
        {
          action: tour.back,
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: tour.next,
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 10, crossAxis: 0 })],
      },
    });
    tour.addStep({
      title: this.$t('plateformcentral.step3title').toString(),
      text: this.$t('plateformcentral.step3text').toString(),
      attachTo: {
        element: '.gallery-photo-preview-action', // La classe CSS de l'élément que vous voulez souligner
        on: 'right',
      },
      buttons: [
        {
          action: tour.back,
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: tour.next,
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 10, crossAxis: -60 })],
      },
      canClickTarget: false,
    });

    tour.addStep({
      title: this.$t('plateformcentral.step4title').toString(),
      text: this.$t('plateformcentral.step4text').toString(),
      attachTo: {
        element: '.gallery-action', // La classe CSS de l'élément que vous voulez souligner
        on: 'right',
      },
      buttons: [
        {
          action: tour.back,
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: tour.next,
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 20, crossAxis: 0 })],
      },
      canClickTarget: false,
    });
    tour.addStep({
      title: this.$t('plateformcentral.step405title').toString(),
      text: this.$t('plateformcentral.step405text').toString(),
      attachTo: {
        element: '.picto-flag', // La classe CSS de l'élément que vous voulez souligner
        on: 'right',
      },
      buttons: [
        {
          action: tour.back,
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: tour.next,
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 20, crossAxis: 0 })],
      },
      canClickTarget: false,
    });
    tour.addStep({
      title: this.$t('plateformcentral.step41title').toString(),
      text: this.$t('plateformcentral.step41text').toString(),
      attachTo: {
        element: '.picto-coeur', // La classe CSS de l'élément que vous voulez souligner
        on: 'right',
      },
      buttons: [
        {
          action: tour.back,
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: tour.next,
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 20, crossAxis: 0 })],
      },
      canClickTarget: false,
    });
    tour.addStep({
      title: this.$t('plateformcentral.step42title').toString(),
      text: this.$t('plateformcentral.step42text').toString(),
      attachTo: {
        element: '.zoomerbtn', // La classe CSS de l'élément que vous voulez souligner
        on: 'right',
      },
      buttons: [
        {
          action: tour.back,
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: tour.next,
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 20, crossAxis: 0 })],
      },
      canClickTarget: false,
    });
    tour.addStep({
      title: this.$t('plateformcentral.step43title').toString(),
      text: this.$t('plateformcentral.step43text').toString(),
      attachTo: {
        element: '.picto-fullscreen', // La classe CSS de l'élément que vous voulez souligner
        on: 'right',
      },
      buttons: [
        {
          action: tour.back,
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: tour.next,
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 20, crossAxis: 0 })],
      },
      canClickTarget: false,
    });
    tour.addStep({
      title: this.$t('plateformcentral.step45title').toString(),
      text: this.$t('plateformcentral.step45text').toString(),
      attachTo: {
        element: '.picto-share', // La classe CSS de l'élément que vous voulez souligner
        on: 'right',
      },
      buttons: [
        {
          action: tour.back,
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: tour.next,
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 20, crossAxis: 0 })],
      },
      canClickTarget: false,
    });
    tour.addStep({
      title: this.$t('plateformcentral.step47title').toString(),
      text: this.$t('plateformcentral.step47text').toString(),
      attachTo: {
        element: '.picto-download', // La classe CSS de l'élément que vous voulez souligner
        on: 'right',
      },
      buttons: [
        {
          action: tour.back,
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: tour.next,
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 20, crossAxis: 0 })],
      },
      canClickTarget: false,
    });
    tour.addStep({
      title: this.$t('plateformcentral.step5title').toString(),
      text: this.$t('plateformcentral.step5text').toString(),
      attachTo: {
        element: '.comparebtn', // La classe CSS de l'élément que vous voulez souligner
        on: 'right',
      },
      buttons: [
        {
          action: tour.back,
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: tour.next,
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 20, crossAxis: 0 })],
      },
      canClickTarget: false,
    });
    tour.addStep({
      title: this.$t('plateformcentral.step6title').toString(),
      text: this.$t('plateformcentral.step6text').toString(),
      attachTo: {
        element: '.timelapsecard', // La classe CSS de l'élément que vous voulez souligner
        on: 'left',
      },
      buttons: [
        {
          action: function () {
            // Aller directement à l'étape 10 (index 9)
            tour.show(3);
          },
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: tour.next,
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 15, crossAxis: 0 })],
      },
      canClickTarget: false,
    });
    tour.addStep({
      title: this.$t('plateformcentral.step7title').toString(),
      text: this.$t('plateformcentral.step7text').toString(),
      attachTo: {
        element: '.scenariicard', // La classe CSS de l'élément que vous voulez souligner
        on: 'right',
      },
      buttons: [
        {
          action: tour.back,
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: function () {
            let gripElement = document.querySelector('.album-title');
            if (gripElement) {
              (gripElement as HTMLElement).click();
            }
            tour.next();
          },
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 15, crossAxis: 0 })],
      },
      canClickTarget: false,
    });
    tour.addStep({
      title: this.$t('plateformcentral.step8title').toString(),
      text: this.$t('plateformcentral.step8text').toString(),
      attachTo: {
        element: '.albumcard', // La classe CSS de l'élément que vous voulez souligner
        on: 'left',
      },
      buttons: [
        {
          action: function () {
            let gripElement = document.querySelector('.album-title');
            if (gripElement) {
              (gripElement as HTMLElement).click();
            }
            tour.back();
          },
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: function () {
            let gripElement = document.querySelector('.album-title');
            if (gripElement) {
              (gripElement as HTMLElement).click();
            }
            let dataElement = document.querySelector('.data-title');
            if (dataElement) {
              (dataElement as HTMLElement).click();
            }
            tour.show(14);
          },
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 15, crossAxis: 0 })],
      },
      canClickTarget: false,
    });
    tour.addStep({
      title: this.$t('plateformcentral.step9title').toString(),
      text: this.$t('plateformcentral.step9text').toString(),
      attachTo: {
        element: '.picto-coeur', // La classe CSS de l'élément que vous voulez souligner
        on: 'left',
      },
      buttons: [
        {
          action: tour.back,
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
      ],
      advanceOn: { selector: '.picto-coeur', event: 'click' },
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 10, crossAxis: 0 })],
      },
    });
    tour.addStep({
      title: this.$t('plateformcentral.step10title').toString(),
      text: this.$t('plateformcentral.step10text').toString(),
      attachTo: {
        element: '.popover', // La classe CSS de l'élément que vous voulez souligner
        on: 'right',
      },
      advanceOn: { selector: '.creeralbum', event: 'click' },
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 10, crossAxis: 0 })],
      },
    });
    tour.addStep({
      title: this.$t('plateformcentral.step11title').toString(),
      text: this.$t('plateformcentral.step11text').toString(),
      attachTo: {
        element: '.datacard', // La classe CSS de l'élément que vous voulez souligner
        on: 'left',
      },
      buttons: [
        {
          action: function () {
            let dataElement = document.querySelector('.data-title');
            if (dataElement) {
              (dataElement as HTMLElement).click();
            }
            let gripElement = document.querySelector('.album-title');
            if (gripElement) {
              (gripElement as HTMLElement).click();
            }
            tour.show(12);
          },
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: function () {
            let dataElement = document.querySelector('.data-title');
            if (dataElement) {
              (dataElement as HTMLElement).click();
            }
            tour.next();
          },
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 15, crossAxis: 0 })],
      },
      canClickTarget: false,
    });
    tour.addStep({
      title: this.$t('plateformcentral.step12title').toString(),
      text: this.$t('plateformcentral.step12text').toString(),
      attachTo: {
        element: '.descriptioncard', // La classe CSS de l'élément que vous voulez souligner
        on: 'left',
      },
      buttons: [
        {
          action: function () {
            let dataElement = document.querySelector('.data-title');
            if (dataElement) {
              (dataElement as HTMLElement).click();
            }
            tour.back();
          },
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: function () {
            let gripElement = document.querySelector('.cc-nsge');
            if (gripElement) {
              (gripElement as HTMLElement).click();
            }
            tour.next();
          },
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 15, crossAxis: 0 })],
      },
      canClickTarget: false,
    });
    tour.addStep({
      title: this.$t('plateformcentral.step13title').toString(),
      text: this.$t('plateformcentral.step13text').toString(),
      attachTo: {
        element: '.cc-157aw', // La classe CSS de l'élément que vous voulez souligner
        on: 'left',
      },
      buttons: [
        {
          action: function () {
            let dataElement = document.querySelector('.cc-1no03');
            if (dataElement) {
              (dataElement as HTMLElement).click();
            }
            tour.back();
          },
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: function () {
            let gripElement = document.querySelector('.cc-nsge');
            if (gripElement) {
              (gripElement as HTMLElement).click();
            }
            tour.next();
          },
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 15, crossAxis: 0 })],
      },
      canClickTarget: false,
    });
    tour.addStep({
      title: this.$t('plateformcentral.step13bistitle').toString(),
      text: this.$t('plateformcentral.step13bistext').toString(),
      attachTo: {
        element: '.download', // La classe CSS de l'élément que vous voulez souligner
        on: 'left',
      },
      buttons: [
        {
          action: function () {
            let dataElement = document.querySelector('.cc-imbb');
            if (dataElement) {
              (dataElement as HTMLElement).click();
            }
            tour.back();
          },
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: function () {
            let gripElement = document.querySelector('.cc-nsge');
            if (gripElement) {
              (gripElement as HTMLElement).click();
            }
            tour.next();
          },
          text: this.$t('projectlist.next').toString(),
          classes: 'shepherd-button-next',
        },
      ],
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 15, crossAxis: 0 })],
      },
    });
    tour.addStep({
      title: this.$t('plateformcentral.step14title').toString(),
      text: this.$t('plateformcentral.step14text').toString(),
      attachTo: {
        element: '.fa-circle-info', // La classe CSS de l'élément que vous voulez souligner
        on: 'bottom',
      },
      buttons: [
        {
          action: function () {
            let dataElement = document.querySelector('.cc-imbb');
            if (dataElement) {
              (dataElement as HTMLElement).click();
            }
            tour.back();
          },
          text: this.$t('projectlist.previous').toString(),
          classes: 'shepherd-button-ignore',
        },
        {
          action: tour.next,
          text: this.$t('projectlist.donotshow').toString(),
          classes: 'shepherd-button-next',
        },
      ],
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 15, crossAxis: 0 })],
      },
    });
    tour.start();
  }

  public startTourNewFeature(): void {
    // Vérifier si l'utilisateur a déjà choisi de ne pas afficher ce tour
    if (localStorage.getItem('tourIgnored-new-feature')) {
      return; // Ne pas afficher le tour si l'utilisateur l'a ignoré
    }

    const tour = new Shepherd.Tour({
      defaultStepOptions: {
        cancelIcon: {
          enabled: true,
        },
        classes: 'shepherd-content', // Ajoutez votre propre classe CSS
        scrollTo: true,
        when: {
          show() {
            const currentStep = Shepherd.activeTour?.getCurrentStep();
            if (!currentStep) return;
            const currentStepElement = currentStep.getElement();
            if (!currentStepElement) return;
            const header = currentStepElement.querySelector('.shepherd-footer');
            if (!header) return;
            const progress = document.createElement('div');
            const innerBar = document.createElement('span');
            const progressPercentage = ((tour.steps.indexOf(currentStep) + 1) / tour.steps.length) * 100 + '%';
            progress.className = 'shepherd-progress-bar';
            innerBar.style.width = progressPercentage;
            progress.appendChild(innerBar);
            header.insertBefore(progress, currentStepElement.querySelector('.shepherd-button'));
          },
        },
      },
      useModalOverlay: true,
      keyboardNavigation: false,
    });

    tour.addStep({
      title: 'Nouvelle fonctionnalité !',
      text: "Cliquez ici pour accéder à la nouvelle fonctionnalité d'ajout d'éléments dans l'album.",
      attachTo: {
        element: '.album-container .fa-plus', // Remplacez 'your-plus-button-class' par la classe CSS exacte du bouton plus
        on: 'bottom',
      },
      buttons: [
        {
          action: () => {
            localStorage.setItem('tourIgnored-new-feature', 'true'); // Enregistrer que l'utilisateur a ignoré ce tour
            tour.complete();
          },
          text: 'Ne plus afficher',
          classes: 'shepherd-button-ignore',
        },
        {
          action: tour.next,
          text: 'Suivant',
          classes: 'shepherd-button-next',
        },
      ],
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 20, crossAxis: 50 })],
      },
    });

    tour.start();
  }

  public showCameraModal() {
    this.$nextTick(() => {
      const cameraModal = this.$refs['camera-modal-' + this.cameraSelected] as (Vue & { show: () => void }) | null;
      if (cameraModal && typeof cameraModal.show === 'function') {
        cameraModal.show();
      } else {
        console.error('Modal not found or show method not available:', 'camera-modal-' + this.cameraSelected);
      }
    });
  }

  public beforeDestroy(): void {
    logger.info('beforeDestroy');
    // called when the route that renders this component is about to
    // be navigated away from.
    // has access to `this` component instance.
    this.disconnectSocket();
  }

  public refreshPhoto(): void {
    if (this.cameraSelected !== null) {
      this.findPhotoAllForProject({ projectId: this.id, cameraId: this.cameraSelected }).then((photos) => {
        console.log('[PlateformCentral] refreshPhoto — photos récupérées', {
          cameraId: this.cameraSelected,
          length: photos ? photos.length : 'undefined',
          sample: photos && photos[0],
        });

        this.photos = photos || [];
        console.log('[PlateformCentral] refreshPhoto — this.photos affecté', {
          length: this.photos.length,
          sample: this.photos[0],
        });

        this.newPhotoAvailable = false;
      });
    }
  }

  public async handleSwitchMode(mode: string | null) {
    this.galleryComparaison = mode;
    console.log('galleryComparaison mis à jour à:', mode);

    if (mode !== null && this.cameraSelected !== null) {
      console.log('Chargement des photos pour la caméra:', this.cameraSelected);
      await this.findPhotoAllForProject({ projectId: this.id, cameraId: this.cameraSelected });
      await this.loadAlbum({ projectId: this.id, cameraId: this.cameraSelected });
      console.log('Photos chargées pour GalleryCompare');
    }
  }

  @Watch('socketMessage.message')
  public onSocketMessageChange(val: NotificationMessage): void {
    if (val && val.photo) {
      switch (val.photo) {
        case 'new_photo':
          if (val.projectId === this.project?.id && val.cameraId === this.cameraSelected) {
            logger.info('new photo');
            this.newPhotoAvailable = true;
            break;
          }
      }
    }
  }

  @Watch('projects')
  public async onStateProjectLoaded(val?: Project[], oldVal?: Project[]): Promise<void> {
    logger.info('onStateProjectLoaded', { val, oldVal });
    this.project = this.projectWithId(this.id) || null;
    if (this.project !== null) {
      await this.setProject(this.project);
      if (this.cameraSelected === null) {
        this.cameraSelected = this.project.camerasId?.[0] ?? this.project.previousCamerasId?.[0] ?? null;
      }
      if (this.cameraSelected !== null) {
        await this.onCameraSelectedChange(this.cameraSelected);
      }
      await this.fetchLogoUrl();
    }
  }

  @Watch('timelapse')
  public onTimelapseLoaded(): void {
    this.lastVideo = this.cameraSelected !== null ? this.timelapseForCamera(this.cameraSelected) : null;
  }

  @Watch('cameraSelected')
  public async onCameraSelectedChange(cameraSelected: string | null): Promise<void> {
    logger.info('onCameraSelectedChange', { query: cameraSelected });

    if (this.$refs.galleryCompare) {
      (this.$refs.galleryCompare as any).resetImages();
    }

    if (!this.project) {
      return;
    }

    if (cameraSelected !== null) {
      const indexCamera: number = this.project.cameras?.findIndex((c) => c.id === cameraSelected) ?? -1;
      const indexPrevious: number = this.project.previousCameras?.findIndex((c) => c.id === cameraSelected) ?? -1;

      if (indexCamera !== -1 || indexPrevious !== -1) {
        this.lastVideo = this.timelapseForCamera(cameraSelected) || null;

        // 🔹 LOG: avant / après appel de l’action Vuex
        const photos = await this.findPhotoAllForProject({ projectId: this.id, cameraId: cameraSelected });
        console.log('[PlateformCentral] onCameraSelectedChange — photos récupérées', {
          cameraId: cameraSelected,
          length: photos ? photos.length : 'undefined',
          sample: photos && photos[0],
        });

        this.photos = photos || [];
        console.log('[PlateformCentral] onCameraSelectedChange — this.photos affecté', {
          length: this.photos.length,
          sample: this.photos[0],
        });

        const albums = await this.loadAlbum({ projectId: this.id, cameraId: cameraSelected });
        this.album = albums.length > 0 ? albums[0] : null;
      } else {
        // Si cameraSelected ne correspond à aucune caméra connue,
        // on force la première caméra dispo
        const firstCameraId = this.project.cameras?.[0]?.id ?? this.project.previousCameras?.[0]?.id ?? null;
        if (firstCameraId) {
          this.cameraSelected = firstCameraId;
        }
      }
    } else {
      // cameraSelected == null → on essaie de sélectionner la première caméra
      const firstCameraId = this.project.cameras?.[0]?.id ?? this.project.previousCameras?.[0]?.id ?? null;
      if (firstCameraId) {
        this.cameraSelected = firstCameraId;
      }
    }
  }
}
